

















































































import {Component, Ref, Vue} from "vue-property-decorator";
import { Action, Getter } from "vuex-class";
import {cloneDeep, isEqual} from "lodash";
import { SelectWings, FieldTooltip, TextareaWings } from "wings-ui-components";
import { notifyConfirm, notifyDelete, notifyError } from "@/utils/notify-helper";
import {MsgTransports} from "@/store/types";
import {SmsFilterItem, SmsFilterItemImpl} from "@/store/sms/filters/types";
import {ActionLog} from "@/store/auth/types";
import {getTranslatedParams} from "@/utils/notify-utils";

Component.registerHooks([
  'beforeRouteLeave',
]);

@Component({components: {SelectWings, FieldTooltip, TextareaWings}})
export default class SmsFilter extends Vue {
  @Getter("smsFilterConditionsList") smsFilterConditionsList: any;
  // @Getter("partners") partnersList: any;
  @Action("getPartners") actionGetPartners: any;
  @Action("getSmsFilterItem") actionGetItem: any;
  @Action("saveSmsFilter") actionSave: any;
  @Action("deleteSmsFilter") actionDelete: any;
  @Action("actionLog") actionLog: any;
  @Ref('validator') validator:any;

  private transport: MsgTransports = MsgTransports.SMS
  private item:SmsFilterItem = new SmsFilterItemImpl();
  private itemSaved:SmsFilterItem = new SmsFilterItemImpl();
  private logObject: ActionLog = {};

  params = {transport: this.transport};
  partnersList: any = []
  filterKeys: object = {
    'channel_ids': 'transport'
  };

  async getPartnersList(filter: any) {
    const items = await this.actionGetPartners({...this.params, ...filter});
    this.partnersList = (filter?.page_number > 1) ? this.partnersList.concat(items) : items
  }

  async created() {
    if (this.$route.params.id) {
      try {
        this.logObject = {
          action_page: this.$route.meta.msgKey,
          action: "Viewing",
          action_status: "success",
          object_type: "The rule for blocking by text",
          addititional_info: getTranslatedParams(this.item, this.filterKeys)
        }
        const data: SmsFilterItem = await this.actionGetItem(this.$route.params.id)
        this.item = Object.assign({}, this.item, data);
        this.itemSaved = cloneDeep(Object.assign({}, this.item, data));
        this.actionLog(this.logObject);
      } catch (error){
        this.actionLog({...this.logObject, action_status: "failed"});
      }
      this.partnersList = await this.actionGetPartners({id: this.item.partner_id});
    }
  }

  back():void{
    this.$router.push(`/${this.transport.toLowerCase()}/filters/`);
  }

  onSaveItem():Promise<void> {
    return new Promise<void>(async (resolve, reject) => {
      let valid:boolean = await this.validator.validate();
      if (valid) {
        try {
          this.logObject = {
            action_page: this.$route.meta.msgKey,
            action: this.$route.params.id ? "Editing" : "Creation",
            action_status: "success",
            object_type: "The rule for blocking by text",
            addititional_info: getTranslatedParams(this.item, this.filterKeys)
          }
          await this.actionSave(this.item);
          await this.actionLog(this.logObject);
          this.itemSaved = this.item;
          resolve();
          this.back();
        } catch (error) {
          await this.actionLog({...this.logObject, action_status: "failed"});
          reject();
          notifyError(error);
        }
      } else {
        setTimeout(() => {
          notifyError(null, this.validator.errors)
        }, 100);
      }
    })
  }

  async onDeleteItem():Promise<void> {
    let isConfirm:boolean = await notifyDelete();
    if (isConfirm) {
      try {
        this.logObject = {
          action_page: this.$route.meta.msgKey,
          action: "Removal",
          action_status: "success",
          object_type: "The rule for blocking by text",
          addititional_info: getTranslatedParams({id: this.item.id})
        }
        await this.actionDelete(this.item);
        await this.actionLog(this.logObject);
        this.itemSaved = this.item;
        this.back();
      } catch (error) {
        await this.actionLog({...this.logObject, action_status: "failed"});
        notifyError(error);
      }
    }
  }

  beforeRouteLeave(to:any, from:any, next:any) {
    let isChange = !isEqual(this.item,this.itemSaved);
    notifyConfirm(isChange, this.onSaveItem, next);
  }

  tk(value: string) {
    return value ? value.replace(/!/, 'not') : value
  }
}
